import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GenericResultResponse } from "../../../../../types/common";
import { getPosAccByIdResponse, PosAcc } from "../../../../../types/pos";
import callApi from "../../../../../utils/api-client";
import { useDispatch } from "react-redux";
import { updateIsLoading } from "../../../../../reducerSlices/loaderSlice";
import RetailPosForm from "../RetailPosForm/RetailPosForm";
import { IRetailPosFormData } from "../../../../../models/IRetailPosFormProps";
import successToast from "../../../../../assets/images/successToast.svg";
import errorToast from "../../../../../assets/images/errorToast.svg";
import { constants } from "../../../../../common/constants/constants";
import { ToastNotification } from "../../../../../common/components/toastNotification/ToastNotification";

function UpdateRetailPosDetails() {
  const { posId } = useParams<{ posId: string }>();
  const [formUpdateState, setFormUpdateState] = React.useState<"edit" | "view">(
    "view"
  );
  const [toastData, setToastData] = useState(constants.defaultToastData);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [posAccount, setPosAccount] = React.useState<
    IRetailPosFormData | undefined
  >(undefined);

  const getPosAccountDetailsById = async (id: string | undefined) => {
    try {
      dispatch(updateIsLoading(true));
      const response = await callApi<
        GenericResultResponse<getPosAccByIdResponse>
      >(
        `admin/pos/${id}`,
        {
          method: "GET",
        },
        "getPosAccountDetailsById_UpdateRetailPosDetails"
      );

      if (!response) {
        return undefined;
      }
      setFormUpdateState(response.data.retail_pos_base_url ? "view" : "edit");
      setPosAccount({
        retailBaseUrl: response.data.retail_pos_base_url || "",
        retailApiKey: response.data.retail_api_key || "",
        retailSecretKey: response.data.retail_secret_key || "",
        business: {
          id: response.data.business_setup_id || "",
          name: response.data.business_name || "",
        },
        retailCompanyName: response.data.retail_pos_comapany_name || "",
        businessSearchName: "",
      });
    } catch (error) {
      console.error("Error fetching POS account details:", error);
    } finally {
      dispatch(updateIsLoading(false));
    }
  };

  useEffect(() => {
    getPosAccountDetailsById(posId);
  }, []);

  const toggleEditView = () => {
    setFormUpdateState((prevState) => (prevState === "view" ? "edit" : "view"));
  };

  const onSubmit = async (data: IRetailPosFormData) => {
    const body = {
      retail_pos_base_url: data.retailBaseUrl,
      retail_api_key: data.retailApiKey,
      retail_secret_key: data.retailSecretKey,
      retail_pos_comapany_name: data.retailCompanyName,
    };
    try {
      dispatch(updateIsLoading(true));
      await callApi<GenericResultResponse<PosAcc>>(
        `admin/pos/${posId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        },
        "updatePOSEntry_UpdateRetailPosDetails"
      );
      setToastData({
        message: "POS linked successfully.",
        status: "Success",
      });
      navigate("/admin/pos");
      return true;
    } catch (error) {
      console.error("Error saving configuration:", error);
      setToastData({
        message:
          error instanceof Error
            ? error.message
            : "Error saving configuration. Please try again.",
        status: "Fail",
      });
      return false;
    } finally {
      setTimeout(() => {
        setToastData(constants.defaultToastData);
      }, 10000);
      dispatch(updateIsLoading(false));
    }
  };

  if (!posAccount) {
    return <></>;
  }

  return (
    <div style={{ padding: "20px" }}>
      <RetailPosForm
        onSubmit={onSubmit}
        initialData={posAccount}
        disableBusinessSelection
        actionButtonLabel={
          posAccount.retailBaseUrl ? "Update POS Details" : "Connect POS"
        }
        isUpdateMode
        formUpdateState={formUpdateState}
        editBtnCallback={toggleEditView}
      />
      {toastData?.message && (
        <ToastNotification
          icon={toastData.status === "Success" ? successToast : errorToast}
          content={toastData?.message}
          position={"top-right"}
          autoClose={2000}
        />
      )}
    </div>
  );
}

export default UpdateRetailPosDetails;
